import { useEffect } from "react"
import { useCallbackRef } from './use1CallbackRefF.js'

export const useEvtListen = async (evtName, handler) => {
  const listener = useCallbackRef(handler)

  useEffect(() => {
    document.addEventListener(evtName, listener)
    return () => {
      document.removeEventListener(evtName, listener)
    }
  }, [])
}